import { BehaviorSubject } from "rxjs";
import { filter } from "rxjs/operators";

import { fetchWrapper } from "data/FetchWrapper";

const stats$ = new BehaviorSubject([]);
const abort$ = new BehaviorSubject(new AbortController());
const baseUrl = `/api/stats`;

export const statsService = {
  stats: stats$,
  byId,
  abort,
  patents: {
    authors: () => _fetch("patents/authors"),
    owners: () => _fetch("patents/owners"),
    evolution: (params) => _fetch("patents/evolution", params),
  },
  publications: {
    publishers: () => _fetch("publications/publishers"),
    venues: () => _fetch("publications/venues"),
    fos: () => _fetch("publications/fos"),
    keywords: () => _fetch("publications/keywords"),
    language: () => _fetch("publications/language"),
  },
  histogram: () => _fetch("histogram"),
};

function mapOptions(chart, id) {
  const switchLabels = ["histogram"].includes(id);
  return {
    hAxis: {
      textPosition: switchLabels ? "none" : "",
    },
    vAxis: {
      textPosition: switchLabels ? "" : "none",
    },
    bar: { groupWidth: "80%" },
    chartArea: {
      left: 0,
      bottom: switchLabels ? 10 : 30,
      width: "100%",
      height: switchLabels ? 210 : 190,
    },
    legend: "none",
    animation: {
      startup: true,
      easing: "linear",
      duration: 1500,
    },
  };
}

function mapData(chart, id) {
  const trimChart = !["histogram"].includes(id);
  const data = chart.data
    .filter((item) => item.value > 0 && item.key !== 9999)
    .map((item) => [`${item.key}`, item.value]);
  data.unshift([chart.xLabel, chart.yLabel]);
  if (trimChart) {
    data.length = 6;
  }
  return data;
}

function mapChartType(id) {
  switch (id) {
    case "histogram":
      return "AreaChart";
    default:
      return "BarChart";
  }
}

function abort() {
  abort$.value.abort();
  abort$.next(new AbortController());
}

function byId(id) {
  return stats$.asObservable().pipe(filter((x) => x && x.id === id));
}

function _fetch(id, params = null) {
  const stat = {
    id,
    params,
  };
  return fetchWrapper
    .get(
      `${baseUrl}/${id}${
        params !== null
          ? `?${Object.keys(params)
              .map((key) => `${key}=${params[key]}`)
              .join("&")}`
          : ""
      }`,
      abort$.value.signal
    )
    .then((result) => {
      if (result.report && result.report && result.report.chart) {
        stat.title = result.report.chart.title;
        stat.data = mapData(result.report.chart, id);
        stat.options = mapOptions(result.report.chart);
        stat.chart = result.report.chart;
        stat.chartType = mapChartType(id);
        const stats = stats$.value.filter((_) => _.id !== id);
        stats.push(stat);
        stats$.next(stats);
      }
      return stat;
    });
}
